import type { Message } from 'slices/aiConversations/types'

import './UserMessage.scss'

export interface UserMessageProps {
  message: Message
}

const UserMessage = ({ message }: UserMessageProps) => {
  // Always render user messages as plain text for security
  return (
    <div className="thanx-ai-conversation__message-content">
      {message.content}
    </div>
  )
}

export default UserMessage
